import c from '@/styles/Strossle';
import { StandaloneComponent } from '@/types/component';
import { useAppState } from 'lib/hooks/useAppState';
import getConfig from 'modules/config';
import Script from 'next/script';
import { useId } from 'react';

const ElementStrossle: StandaloneComponent = () => {
  const [{ affiliate }] = useAppState();
  const id = useId().replace(/:/g, '');

  const strossleConfig = getConfig('strossle') || {};

  const strossleEnabled = strossleConfig.enabled || false;
  const strossleId = strossleConfig.id || '';

  if (!strossleEnabled || !strossleId) return null;

  return (
    <div data-affiliate={affiliate} className={c`wrapper`}>
      <Script
        id="strossle-v2-widget-sdk"
        src="https://assets.strossle.com/strossle-widget-sdk/1/strossle-widget-sdk.js"
      ></Script>
      <div data-widgetid={strossleId} id={`strossle-widget-${id}`}></div>
      <Script id={`load-strossle-${id}`}>
        {`window.strossle=window.strossle||function(){(strossle.q=strossle.q||[]).push(arguments)};
        strossle('${strossleId}', '#strossle-widget-${id}');`}
      </Script>
    </div>
  );
};

export default ElementStrossle;
